//@flow
import React, { Component } from 'react';
import { type IntlShape } from 'react-intl';

import type { DirSvcMappingEntry, Role } from 'state/types';
import { getLocalizedRoleName, getRoleForUUID } from 'util/roleUtils';
import { getUserName, SOURCE_TYPE_USER_EXCLUSION } from 'util/dirSvcUtils';

type Props = {
  addOrUpdateMappingEntries: Function,
  entry: DirSvcMappingEntry,
  intl: IntlShape,
  isSelected: boolean,
  onSelectNode: Function,
  roles: Role[],
  showRoles: boolean,
};

export default class DestinationNode extends Component<Props> {
  handleSelect: Function;
  onChangeSelectRole: Function;
  onChangeSelectRole: Function;
  renderIcon: Function;
  renderRole: Function;

  constructor() {
    super();
    this.handleSelect = this.handleSelect.bind(this);
    this.onChangeSelectRole = this.onChangeSelectRole.bind(this);
    this.onChangeSelectRole = this.onChangeSelectRole.bind(this);
    this.renderIcon = this.renderIcon.bind(this);
    this.renderRole = this.renderRole.bind(this);
  }

  handleSelect() {
    const { entry, onSelectNode } = this.props;
    onSelectNode(entry);
  }

  onChangeSelectRole(e: SyntheticMouseEvent<HTMLInputElement>) {
    const { addOrUpdateMappingEntries, entry } = this.props;
    addOrUpdateMappingEntries([
      { ...entry, roleOverrideGuid: e.currentTarget.value },
    ]);
  }

  renderIcon() {
    const { entry } = this.props;
    const name = getUserName(entry.sourceDN);
    const icon =
      entry.sourceType === SOURCE_TYPE_USER_EXCLUSION
        ? 'fa-minus-circle'
        : 'fa-arrow-circle-right';
    return (
      <div className="dir-svc-mapping-column">
        <div className="dir-svc-cell">
          <span className="icon is-large">
            <i className={`fa fa-lg ${icon}`} />
          </span>
          <div
            className="dir-svc-cell"
            data-test-name={
              entry.sourceType === SOURCE_TYPE_USER_EXCLUSION
                ? 'excluded-user'
                : 'mapped-user'
            }
          >
            {name}
          </div>
        </div>
      </div>
    );
  }

  renderRole() {
    const { entry, intl, roles } = this.props;
    const role = getRoleForUUID(roles, entry.roleOverrideGuid);
    const roleName = role ? role.name : '-';
    if (entry.sourceType === SOURCE_TYPE_USER_EXCLUSION) {
      return null;
    }
    return entry.unsaved ? (
      <div className="dir-svc-role-select">
        <div className="select">
          <select
            onChange={this.onChangeSelectRole}
            value={entry.roleOverrideGuid}
          >
            {roles.map(r => (
              <option key={r.uuid} value={r.uuid}>
                {getLocalizedRoleName(intl, r.name)}
              </option>
            ))}
          </select>
        </div>
      </div>
    ) : (
      <div
        key="display-role"
        className="dir-svc-mapping-column dir-svc-cell dir-svc-cell-padded"
      >
        {roleName}
      </div>
    );
  }

  render() {
    const { entry, isSelected, showRoles } = this.props;
    const rowClass = isSelected
      ? 'pseudo-table-row-selected'
      : 'pseudo-table-row';

    return (
      <li className={rowClass} key={entry.sourceDN} onClick={this.handleSelect}>
        <div className="dir-svc-row">
          {this.renderIcon()}
          {showRoles && this.renderRole()}
        </div>
      </li>
    );
  }
}



// WEBPACK FOOTER //
// ./src/view/Pages/DirectoryServicesPage/DestinationNode.js